// User Auth
import Login from "@/views/eldac-auth/Login";
import Register from "@/views/eldac-auth/Register";
import ResetPassword from "@/views/eldac-auth/ResetPassword";
import NewPassword from "@/views/eldac-auth/NewPassword";
// User Main
import Greeting from "@/views/eldac-main/Greeting";
import Search from "@/views/eldac-main/Search";
import Resources from "@/views/eldac-main/Resources";
import Test from "@/views/eldac-main/Test";

// Admin Auth
import AdminLogin from "@/views/eldac-admin/auth/AdminLogin";
import AdminProjects from "@/views/eldac-admin/main/AdminProjects";
import AdminResources from "@/views/eldac-admin/main/AdminResources";
import AdminPrograms from "@/views/eldac-admin/main/AdminPrograms";
import AdminTags from "@/views/eldac-admin/main/AdminTags";
import AdminUsers from "@/views/eldac-admin/main/AdminUsers";
import AdminUserMetrics from "@/views/eldac-admin/main/AdminUserMetrics";

// layout
import Adminlayout from "@/layouts/full-layout/Adminlayout";
import Blanklayout from "@/layouts/blank-layout/Blanklayout";
import Authlayout from "@/layouts/blank-layout/Authlayout";
import Greetinglayout from "@/layouts/blank-layout/Greetinglayout";

export const routes = [
    {
        path: "/",
        redirect: "/",
        component: Greetinglayout,
        children: [
            {
                name: "Greeting",
                path: "/",
                component: Greeting,
                meta: {
                    publicRoute: true
                }
            },
        ]
    },

    {
        path: "/",
        component: Blanklayout,
        children: [
            {
                name: "Search",
                path: "search",
                component: Search,
                meta: {
                    publicRoute: true
                }
            },
            {
                name: "Resources",
                path: "resources",
                component: Resources,
                meta: {
                    publicRoute: true
                }
            }
        ]
    },

    {
        path: "/auth",
        redirect: "auth/login",
        component: Blanklayout,
        children: [
            // {
            //     name: "Login",
            //     path: "login",
            //     component: Login,
            //     meta: {
            //         publicRoute: true
            //     }
            // },
            // {
            //     name: "Register",
            //     path: "register",
            //     component: Register,
            //     meta: {
            //         publicRoute: true
            //     }
            // },
            // {
            //     name: "ResetPassword",
            //     path: "resetpassword",
            //     component: ResetPassword,
            //     meta: {
            //         publicRoute: true
            //     }
            // },
            {
                name: "NewPassword",
                path: "newpassword",
                component: NewPassword,
                meta: {
                    publicRoute: true
                }
            },
        ]
    },

    {
        path: "/admin/auth",
        redirect: "admin/auth/login",
        component: Authlayout,
        children: [
            {
                name: "AdminLogin",
                path: "login",
                component: AdminLogin,
                meta: {
                    publicRoute: true
                }
            }
        ]
    },

    {
        path: "/admin",
        redirect: "admin/projects",
        component: Adminlayout,
        children: [
            {
                name: "AdminProjects",
                path: "projects",
                component: AdminProjects
            },
            {
                name: "AdminResources",
                path: "resources",
                component: AdminResources
            },
            {
                name: "AdminPrograms",
                path: "programs",
                component: AdminPrograms
            },
            {
                name: "AdminTags",
                path: "tags/:tagType",
                component: AdminTags
            },
            {
                name: "AdminUsers",
                path: "users",
                component: AdminUsers
            },
            {
                name: "AdminUserMetrics",
                path: "usermetrics",
                component: AdminUserMetrics
            }
        ]
    },
];
